(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rfq-price-guard"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rfq-price-guard')) {
    customElements.define('rfq-price-guard', class extends HTMLElement {
      connectedCallback() {
        this.productRoot = this.closest('.product--outer');
        this.onVariantChange = (event) => {
          const { variant, product } = event.detail || {};
          const hidePrice = variant
            ? Number(variant.price) <= 1
            : Boolean(product?.variants?.length) && product.variants.every(item => Number(item.price) <= 1);
          this.productRoot.toggleAttribute('data-rfq-quote-only', hidePrice);
          this.productRoot.querySelectorAll('[data-product-pricing]').forEach(element => {
            element.toggleAttribute('data-rfq-hide-price', hidePrice);
          });
        };
        this.onSubmit = (event) => {
          if (this.productRoot.hasAttribute('data-rfq-quote-only') && event.target.matches('form[data-product-form]')) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        };
        this.productRoot?.addEventListener('variant-change', this.onVariantChange, true);
        this.productRoot?.addEventListener('submit', this.onSubmit, true);
      }
      disconnectedCallback() {
        this.productRoot?.removeEventListener('variant-change', this.onVariantChange, true);
        this.productRoot?.removeEventListener('submit', this.onSubmit, true);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
